<app-module-title>
  <h1 class="title is-1" i18n="Dashboard main title">
    {{ 'dashboard.dashboard' | translate }}
  </h1>
</app-module-title>
<app-spinner [loading]="loading$ | async" size="full"></app-spinner>
<div class="container">
  <app-block>
    <h3 class="title is-4" block-title>
      {{ 'dashboard.booking-title' | translate }}
    </h3>
    <app-booking-search
      (submitBookingSearch)="submitBookingSearch($event)"
      block-content
    ></app-booking-search>
  </app-block>
</div>
